import { render } from "./ProductInventoryCoveragePage.vue?vue&type=template&id=47e9740e"
import script from "./ProductInventoryCoveragePage.vue?vue&type=script&lang=js"
export * from "./ProductInventoryCoveragePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__